export default __webpack_public_path__ + "static/media/Bracers of Vernant Fury.9d767a20.jpg";